module.exports = __webpack_public_path__ + "img/error.a6f303d7.svg";